/**
 * useSlotT -- hook variant of tCms() that reads the current locale from
 * react-i18next automatically. Use in React components:
 *
 *   const slotT = useSlotT('home')
 *   <h2>{slotT('home.about.title')}</h2>
 *
 * Lookup chain:
 *   1. cmsOverrides[locale][key]   CMS override (from generated TS file)
 *   2. i18next.t(key, { lng: locale })   existing JSON fallback
 *   3. '' (empty string)
 *
 * IMPORTANT: `pageSlug` is fixed at hook creation so it can be tree-shaken
 * correctly (the cmsOverrides object is keyed by pageSlug).
 */

import { useTranslation } from 'react-i18next'
import type { Locale } from '@/admin/api'
import { tCms as tCmsImpl } from './tCms'

export function useSlotT(pageSlug: string): (slotKey: string) => string {
  const { i18n } = useTranslation()
  const locale = (i18n.language || 'zh-Hant') as Locale
  return (slotKey: string) => tCmsImpl(pageSlug, slotKey, locale)
}
